import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { twMerge } from "@/utils/twMerge";

import type { Corner } from "./CorneredBox";
import type { NodeSize } from "@corca/data";

export const LABEL_CORNERS: Corner[] = ["bottom-right"];

const LABEL_CLASSES: Record<NodeSize, string> = {
  sm: "text-[0.625rem]/[1] translate-y-[3px] -mr-1",
  xs: "text-[0.5rem]/[1] translate-y-[2px] -mr-0.75",
  xxs: "text-[0.4375rem]/[1] translate-y-[2px] -mr-0.75",
  xxxs: "text-[0.375rem]/[1] translate-y-[1px] -mr-0.5",
};

export function ComputedRefIndex({ label }: { label: string }) {
  const { size } = useNodeStyle();

  return (
    <div aria-hidden className="flex items-end select-none">
      <div className={twMerge("text-gray-500", LABEL_CLASSES[size])}>{label}</div>
    </div>
  );
}
